<template>
    <div :style="screenHeight">
        <div class="fixed_search">
            <div class="fixed_search_input">
                <Input v-model="slaName" placeholder="请输入SLA规则名称" clearable/>
            </div>
            <div class="fixed_search_input orderTypeStyle">
                <Select v-model="orderType" placeholder="请选择工单类型" multiple clearable>
                    <Option v-for="item in orderTypeList" :value="item.id" :key="item.id">{{item.dictValue}}</Option>
                </Select>
            </div>
            <div class="fixed_search_input">
                <Input v-model="slaDescr" placeholder="请输入备注" clearable/>
            </div>
            <div class="fixed_operation_btn" style="width: auto">
                <Button type="primary" @click="initSearch">查询</Button>
                <Button v-if="roleList['3_d-4-1']" type="info" @click="addSla">添加</Button>
            </div>
        </div>
        <div class="fixed_table">
          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
          <div class="table_head">
            <table>
              <tr>
                <th class="font_style_set" style="width:25%">SLA规则名称</th>
                <th class="font_style_set" style="width:25%">工单类型
                    <el-tooltip class="el_tips_font" effect="light" placement="top">
                    <div slot="content">
                      默认SLA规则仅对无自定义SLA的工单类型适用。
                    </div>
                    <img :src="questionMark"/>
                  </el-tooltip>
              </th>
                <th class="font_style_set" style="width:25%">备注</th>
                <th class="font_style_set" style="width:25%">操作</th>
              </tr>
            </table>
          </div>
          <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
            <table class="table_head_footer">
              <tr v-for="(item,index) in tableContentList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                <td :title="item.slaName" style="width:25%">{{item.slaName}}</td>
                <td :title="item.orderType" style="width:25%">{{item.orderType}}</td>
                <td :title="item.slaDescr" style="width:25%">{{item.slaDescr}}</td>
                <td class="template_table_btn" style="width:25%">
                  <span class="search_btn" v-if="roleList['3_d-4-2']" @click="editSla(item.id)">编辑</span>
                  <!-- 等于0说明是系统初始化的，不允许删除 -->
                  <span class="search_btn" v-if="roleList['3_d-4-3']" :class="{ 'notClick' : item.orderTypeId == '0' }" @click="item.orderTypeId != '0' ? delSla(item.id) : ''">删除</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
       <SlaPagePop :showPop="showPop" @closeSlaPop="closeSlaPop" :slaId="slaId"></SlaPagePop>
    </div>
</template>
<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'
import SlaPagePop from '@/components/systemSetup/worknote/SlaPagePop.vue'
export default {
    name: "SlaPage",
    mixins:[publicFunClass],
    components:{
        SlaPagePop,
    },
    props:{
    },
    data(){
      return{
          showPop: false,
          total:0,
          spinShow: false,
          questionMark:require('../../../assets/image/homeAsk.png'),
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          speedChangePage: 1,
          pageSize:20,
          roleList: JSON.parse(localStorage.getItem("roleList")),
          screenHeight:{height:''},
          tableHeight:{height:''},
          slaName:'',
          orderType: '',
          tableHeadList:[{value:"slaName",label:"SLA规则名称"},{value:"orderType",label:"工单类型"},{value:"slaDescribe",label:"备注"}],
          tableContentList:[],
          slaId:"",
          slaDescr: '',
          orderTypeList:[],
      }
    },
    methods:{
        initSearch:function(){
          let param = {
            id : "",
            slaName : this.slaName,
            orderType : this.orderType.length > 0 ? this.orderType : "",
            slaDescr : this.slaDescr,
          }
          let that = this;
          this.$http.post("sla/toIndex.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.tableContentList = res.data.obj.list.content;
                that.orderTypeList = res.data.obj.orderTypeList;
                that.total = res.data.obj.list.totalSize;
              })
        },
        addSla:function(){
          this.slaId = "-1";
          this.showPop = true;
        },
        editSla:function(id){
          this.slaId = id+"";
          this.showPop = true;
        },

        delSla:function(id){
          let param = {
            id : id,
            journalType:"系统管理=>工单配置=>删除SLA",
            menuId:"3_d-4-3"
          }
            let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否删除SLA",
            onOk: () => {
              that.$http.post("sla/doDelete.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.$Message.success(res.data.msg);
                that.initSearch();
              })
            }
          });
        },
        closeSlaPop:function(flag){
            this.showPop = false;
            this.slaId = "";
            if(flag){
              this.initSearch();
            }
        },
    },
    created(){
        this.screenHeight.height=this.mountHeight(92);
        this.tableHeight.height=this.mountHeight(220);
        this.initSearch();
    }
}
</script>
<style scoped>
.notClick{
  color: #C0C4CC !important;
  cursor: not-allowed !important;
}
.el_tips_font{
    text-align: left;
    padding-left: 0px;
    width: 15px;
    height: 15px;
  }
 
 .orderTypeStyle /deep/ .ivu-icon{
   line-height: 18px!important;
  height: 25px;
 }
  
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/SlaPage.vue